import {ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import {GlobalService} from '../../../../global.service';
import {EventsService} from '../../../events/events.service';
import {AuthenticationService} from '../../../../authentication.service';
import {SeasonsService} from '../../seasons.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {UsersService} from '../../../users/users.service';

@Component({
  selector: 'elastic-signup-dialog',
  templateUrl: './signup-dialog.component.html',
  styleUrls: ['./signup-dialog.component.scss']
})
export class SignupDialogComponent implements OnInit {


  driverEntry = {
      'vorname' : '',
      'nachname' : '',
      'shortname' : '',
      'car_model' : -1,
      'twitch_channel' : '',
      'youtube_channel' : '',
      'origin' : '',
      'code_of_conduct' : false,
      'chat' : false,
      'redletters': false,
      'livery': 0,
      'team_id': 0
    };
  raceRoomContent = [];

  activeCarClasses = [];
  allowedChanges = {};

  originalCar = -1;

  signUpShown = true;
  rollingStartAC = false;
  rollingStartAMS2 = false;
  ams2betaHint = false;

  proseriesCarchange = false;

  responseMessage = '';
  responseError = false;
  countrySearch: string;
  nocarchange = false;

  liveries = [];

  slogan: any;

  simucubelink: string;

  allowedcars = [];

  cars = [];

  myteam = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<SignupDialogComponent>,
              private globalService: GlobalService,
              private eventsService: EventsService,
              private authenticationService: AuthenticationService,
              private seasonsService: SeasonsService,
              private cdr: ChangeDetectorRef,
              private usersService: UsersService) { }

  ngOnInit() {

    console.log(this.data.event);
    console.log(this.authenticationService.getUserSr());
    this.seasonsService.getAvailableCars(this.data.event.event_id, this.data.race.race_id).subscribe( (data: any) => {
      if (data) {
        this.cars = data;
        if (this.cars.length == 1) {
          this.driverEntry.car_model = this.cars[0].car_id;
          this.driverEntry.livery = 0;
        }
      }

        if (this.data.event.sim_id == 6) {
          this.globalService.getUserRaceRoomContent(this.authenticationService.getUserId()).subscribe( (data: any) => {
            if (data) {
              this.raceRoomContent = data.content_ids;
            }
          });
        }

    });
    if (this.data.event.sim_id == 4) {
      //this.ams2betaHint = true;
      //this.signUpShown = false;
    }
    if (this.data.event.settings.rolling_start !== undefined) {
      if (this.data.event.sim_id == 3 && this.data.event.settings.rolling_start == true) {
        this.rollingStartAC = true;
        this.signUpShown = false;
      }
    }
    this.simucubelink = btoa('https://simucube.com/store/?utm_campaign=simucube-brand&utm_medium=banner&utm_source=lfm&utm_content=message&utm_term=gear-up');
    this.getUsersLiveries();
    this.slogan = this.globalService.getSimuCubeSlogan();

    if (this.authenticationService.isLoggedIn()) {

      this.usersService.getMyTeam().subscribe(
        ( response: HttpEvent<any> ) => {
          switch (response.type) {
            case HttpEventType.Response:
              this.myteam = response.body;
              if (this.myteam[this.myteam.length - 1].team_id) {
                this.driverEntry.team_id = this.myteam[this.myteam.length - 1].team_id;
              }
              break;
          }
        });

      if (this.authenticationService.currentUser.lastTeam > 0) {
        this.driverEntry.team_id = this.authenticationService.currentUser.lastTeam;
      }

      if (this.data.signedUp) {

        this.seasonsService.getSignUpData(this.data.race.race_id).subscribe(
          ( response: HttpEvent<any> ) => {
            switch (response.type) {
              case HttpEventType.Response:
                //console.log(response.body);
                let driverData = this.authenticationService.getUserData();
                this.driverEntry.vorname = response.body.driver_data.vorname;
                this.driverEntry.nachname = response.body.driver_data.nachname;
                this.driverEntry.shortname = response.body.driver_data.shortname;
                this.driverEntry.twitch_channel = driverData.twitch_channel;
                this.driverEntry.youtube_channel = driverData.youtube_channel;
                this.driverEntry.origin = driverData.origin;
                this.driverEntry.car_model = response.body.car_model;
                this.driverEntry.livery = response.body.livery != null ? response.body.livery : 0;
                this.driverEntry.team_id = response.body.driver_data.team_id;

                console.log(this.driverEntry);
                if (this.data.event.fixed_car*1 == 1) {

                  this.seasonsService.checkForUserFixedCar(this.data.event.event_id, this.data.race.race_id).subscribe( (data:any) => {
                    if (data.car*1 > -1) {
                      this.driverEntry.car_model = data.car;
                      this.originalCar = data.car;
                      this.nocarchange = true;

                      /*

                      if (this.data.event.event_id*1 == 117 && (this.originalCar*1 == 24 || this.originalCar*1 == 16 || this.originalCar*1 == 23 || this.originalCar == 22)) {
                        this.proseriesCarchange = true;
                      }
                      */
                      if (this.cars.length == 1 && this.driverEntry.car_model != this.cars[0].car_id) {
                        this.driverEntry.car_model = this.cars[0].car_id;
                        this.driverEntry.livery = 0;
                      }
                      this.cdr.detectChanges();
                    }

                  });

                }
                break;
            }
          });


      } else {

        let driverData = this.authenticationService.getUserData();
        console.log(driverData);
        this.driverEntry.vorname = driverData.vorname;
        this.driverEntry.nachname = driverData.nachname;
        this.driverEntry.shortname = driverData.shortname;
        this.driverEntry.twitch_channel = driverData.twitch_channel;
        this.driverEntry.youtube_channel = driverData.youtube_channel;
        this.driverEntry.origin = driverData.origin;
        this.driverEntry.livery = 0;

      }



      //console.log(this.data.event);


      this.data.event.settings.championship_settings.car_classes.forEach(function(carClass) {
        this.activeCarClasses.push(carClass.class);
        if (carClass.allowed_cars) {
          carClass.allowed_cars.forEach( function(c) {
            this.allowedcars.push(c);
          }, this);
        }
        console.log(this.allowedcars);
      }, this);



      console.log(this.activeCarClasses);

      this.driverEntry.car_model = -1;

      this.activeCarClasses.forEach( (carclass) => {
        if (this.authenticationService.currentUser.lastCars[this.data.event.sim_id][carclass]) {
          this.driverEntry.car_model = this.authenticationService.currentUser.lastCars[this.data.event.sim_id][carclass].model;
          this.driverEntry.livery = this.authenticationService.currentUser.lastCars[this.data.event.sim_id][carclass].livery;
          if (this.allowedcars.length > 0) {
            if (this.allowedcars.indexOf(this.driverEntry.car_model) == -1) {
              this.driverEntry.car_model = -1;
              this.driverEntry.livery = 0;
            }
          }
        }
      });

      if (!(this.data.event.class_license_req.length == 0) && this.driverEntry.car_model != -1) {
        let carClass = '';
         this.eventsService.cars.forEach( (car: any) => {
           if (car.car_id == this.driverEntry.car_model) {
             carClass = car.class;
             console.log(carClass);
           }
         });
        if (carClass != '') {
          if (this.globalService.licenseRanks[this.authenticationService.getUserSimLicense(this.data.event.sim_id*1)]*1 < this.globalService.licenseRanks[this.data.event.class_license_req[carClass]]*1) {
            this.driverEntry.car_model = -1;
          } else {
            console.log("passt scho!");
          }

        }
      }


      /*
      if(this.authenticationService.currentUser.lastCars.GT4 && this.activeCarClasses.indexOf('GT4') != -1) {
        this.driverEntry.car_model = this.authenticationService.currentUser.lastCars[this.data.event.sim_id].GT4*1;
      }

      if(this.authenticationService.currentUser.lastCars.GT3 && this.activeCarClasses.indexOf('GT3') != -1) {
        this.driverEntry.car_model = this.authenticationService.currentUser.lastCars.GT3*1;
      }

      if(this.authenticationService.currentUser.lastCars.CUP && this.activeCarClasses.indexOf('CUP') != -1) {
        this.driverEntry.car_model = this.authenticationService.currentUser.lastCars.CUP*1;
      }

      if(this.authenticationService.currentUser.lastCars.TCX && this.activeCarClasses.indexOf('TCX') != -1) {
        this.driverEntry.car_model = this.authenticationService.currentUser.lastCars.TCX*1;
      }*/

      if (this.data.event.fixed_car*1 == 1) {

        this.seasonsService.checkForUserFixedCar(this.data.event.event_id, this.data.race.race_id).subscribe( (data:any) => {
          if (data.car*1 > -1) {
            this.driverEntry.car_model = data.car;
            this.originalCar = data.car;
            this.nocarchange = true;

            /*
            if (this.data.event.event_id*1 == 117 && (this.originalCar*1 == 24 || this.originalCar*1 == 16 || this.originalCar*1 == 23 || this.originalCar == 22)) {
              this.proseriesCarchange = true;
            }*/
            if (this.cars.length == 1 && this.driverEntry.car_model != this.cars[0].car_id) {
              this.driverEntry.car_model = this.cars[0].car_id;
              this.driverEntry.livery = 0;
            }


            this.cdr.detectChanges();
          }
        });

      } else {

        this.globalService.checkUserCarForEvent(this.data.event.event_id, this.authenticationService.getUserId()).subscribe( (data: any) => {
          if (data) {
            if (data.car_model*1 != -1) {
              this.driverEntry.car_model = data.car_model*1;
              if (this.allowedcars.length > 0) {
                if (this.allowedcars.indexOf(this.driverEntry.car_model) == -1) {
                  this.driverEntry.car_model = -1;
                  this.driverEntry.livery = 0;
                }
              }
              this.cdr.detectChanges();
            }
          }
        });


      }

    }

  }

  change() {
    console.log(this.driverEntry);
  }

  save(signedUp) {
    let selectedClass = '';
    this.eventsService.cars.forEach( (car: any) => {
      if (car.server_value == this.driverEntry.car_model) {
        selectedClass = car.class;
      }
    });

    if (this.data.event.class_sr_req && this.checkSrClass(selectedClass) != true) {
      alert('Your SR License is to low for ' + selectedClass);
      return false;
    }
    let carOk = false;
    this.cars.forEach((car: any) => {
      if (car.car_id == this.driverEntry.car_model) {
        carOk = true;
      }
    });

    if (!carOk) {
      alert("The selected car is not available to use in that race!");
      return false;
    }

    if (this.driverEntry.livery != 0) {
      this.liveries.forEach( (liv) => {
        if (liv.livery_id == this.driverEntry.livery) {
          if (liv.car_model != this.driverEntry.car_model) {
            this.driverEntry.livery = 0;
          }
        }
      });
    }

    if (signedUp) {
      this.seasonsService.changeSignUp(this.data.race.race_id, this.driverEntry).subscribe(
        ( response: HttpEvent<any> ) => {
          switch (response.type) {
            case HttpEventType.Response:
              //console.log(response.body);
              this.responseMessage = response.body.message;
              this.responseError = !response.body.success;

              if (!this.responseError) {
                this.dialogRef.close('registered');
                this.authenticationService.updateUserCookie();
              }

              break;
          }
        });
    } else {
      this.seasonsService.signUp(this.data.race.race_id, this.driverEntry).subscribe(
        ( response: HttpEvent<any> ) => {
          switch (response.type) {
            case HttpEventType.Response:
              //console.log(response.body);
              this.responseMessage = response.body.message;
              this.responseError = !response.body.success;

              if (!this.responseError) {
                this.dialogRef.close('registered');
                this.authenticationService.updateUserCookie();
              }

              break;
          }
        });
    }


  }

  getUsersLiveries() {
    if (this.data.event.sim_id == 1 || this.data.event.sim_id == 3) {
      this.globalService.getUsersLiveries(this.data.event.sim_id).subscribe( (data: any) => {
        if (data.length > 0) {
          this.liveries = data;
        }
      });
    }
  }

  checkSrClass(cl) {
      //console.log("Class: " + cl);
      //console.log("Expected SR for class: "+ this.data.event.class_sr_req[cl]);
      //console.log("User SR: " + this.authenticationService.getUserSr());

      if (this.data.event.class_sr_req[cl]*1 > this.authenticationService.getUserSr()*1) {
        //console.log("NO! " + cl);
        return false;
      } else {
        //console.log("YES! " + cl);
        return true;
      }

  }

}
